/**
 * Classifies user's initial text (or description) to either
 * a project or a contest.
 * The initial text/description is used for the id.
 */
export interface ProjectContestClassification {
  readonly id: string;
  readonly classification: ProjectContestClassificationEnum;
}

export enum ProjectContestClassificationEnum {
  PROJECT_ONLY = 'project only',
  PROJECT_RECOMMENDED = 'project recommended',
  CONTEST_RECOMMENDED = 'contest recommended',
  EITHER = 'either',
}
